module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-DemiLight.4028af33.otf";